import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = null as null | string;

const slice = createSlice({
  name: 'googleReCaptcha',
  initialState,
  reducers: {
    setGoogleReCaptcha(state, action: PayloadAction<null | string>) {
      return action.payload || initialState;
    },
  },
});

export const { setGoogleReCaptcha } = slice.actions;

export default slice.reducer;
